import React, { Component } from 'react'
import SimpleModal from "../../common/components/simple-modal";
import UserAvatar from "../../avatars/components";
import UserProfileLink from "../../common/components/user-profile-link";

const TaggedGuestsModal = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    // Only update on modal open
    return nextProps.isModalOpen !== this.props.isModalOpen;
  },
  render() {
    return (
      <SimpleModal
        isOpen={this.props.isModalOpen}
        onCloseClick={this.props.onClose}
        modalClassName="tagged-guests-modal"
        modalId="tagged-guests-modal"
        centered={true}
      >
        <h1>People tagged in this post</h1>
        <ul>
          {this.taggedGuestNodes(tags)}
        </ul>
      </SimpleModal>
    )
  },
  taggedGuestNodes(tags) {
    let nodes = [];
    this.props.tags.map(function(user, idx) {
      nodes.push(
        <li key={user.user_id}>
          <UserAvatar
            userId={user.user_id}
            firstName={user.name}
            size="small"
          />
          <UserProfileLink
            userId={user.user_id}
            firstName={user.name}
          />
        </li>
      );
    });
    return nodes;
  }
})

export default TaggedGuestsModal;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/tagged-guests-modal.es6